import { NgModule } from '@angular/core';
import { AuthService } from '../services/auth.service';

@NgModule()
export class AuthModule {
  // AuthService is injected here to ensure the Amplify Hub listener is initialized
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  constructor(_authService: AuthService) {
    console.log('AuthModule initialized');
  }
}
